import { render, staticRenderFns } from "./ModernSampleDetail.vue?vue&type=template&id=42fe3fd8&scoped=true"
import script from "./ModernSampleDetail.vue?vue&type=script&lang=js"
export * from "./ModernSampleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fe3fd8",
  null
  
)

export default component.exports